
































































import { Component, Vue } from "vue-property-decorator";
import {
	SelectedCountry,
	RedCapital,
	TitleTemplateDashboard,
} from "@/configuration";
import API from "@/api";
import TableResponsive from "@/components/table/TableResponsive.vue";
import ShowLoading from "@/components/panel/ShowLoading.vue";
// @ts-ignore
import jsPDF from "jspdf";
import { mapState } from "vuex";
import { numeroALetras } from "@/utils";
import { EventBus } from "@/main";

@Component({
	metaInfo: {
		title: "Documentos",
		titleTemplate: TitleTemplateDashboard,
		htmlAttrs: {
			// @ts-ignore
			lang: RedCapital[SelectedCountry].Lang,
		},
	},
	computed: {
		...mapState(["user","setOpenMenuPanel"]),
		setOpenMenuPanel(){
			return this.$store.state.openMenuPanel;
		},
	},
	data() {
		return {
			dialog:false,
			numeroALetras,
			RedCapital,
			SelectedCountry,
			canShow: false,
			pdfId: null,
			pdfDownload: null,
			selectedTerm: 1,
			filteredTerms: null,
			informacionPDF: null,
			country: null,
			busqueda: "",
			terms: null,
			tablaDeclaraciones: {
				headers: [
					{
						text: "Nombre contrato",
						align: "center",
						value: "nombre_inversionista",
					},
					{
						text: "Rut",
						align: "center",
						value: "rut_con_formato",
					},
					{
						text: "ID ",
						align: "center",
						value: "id_inversionista",
					},
					{
						text: "tipo ",
						align: "center",
						value: "tipo",
					},
					{
						text: "Año",
						align: "center",
						value: "ano_declaracion",
					},
					{
						text: "Acciones",
						align: "center",
						sortable: false,
					},
				],
				msjEmpty: 'No existen registros en tu cuenta',
				rowsPerPage: {
					txt: 'Registro por página',
					itm: [10, 25, 50, { text: 'Todos', value: -1 }]
				},
				/* pagination: {
					sortBy: "fecha",
					descending: true,
				}, */
			},
			term: null,
		};
	},
	watch: {
		/*selectedTerm(val) {
			this.$data.term = this.$data.terms.find((term: any) => term.id == val);
		}*/
	},
	async beforeMount() {
		let respuestaApi = await API.declarationes(this.$store.state.user.id);
		// @ts-ignore
		this.$data.filteredTerms = respuestaApi.data.data;
		/* Formatear data */
		Array.from(this.$data.filteredTerms, declaracion =>{
			let propsObjTableAll = {
				style: `text-align: center;
						font-size: 0.7rem;
						font-weight: 500;
						color: #8b8b8b`
			}
			let propsObjTableButtons = {
				style: `display: flex;
						justify-content: center;`
			}
			let objTable = {
				nombreContrato:{
					// @ts-ignore
					value: declaracion.nombre_inversionista,
					label: 'Nombre contrato',
					props: propsObjTableAll
				},
				rut:{
					// @ts-ignore
					value: declaracion.rut_con_formato,
					label: 'Rut',
					props: propsObjTableAll
				},
				id:{
					// @ts-ignore
					value: declaracion.id_inversionista,
					label: 'ID',
					props: propsObjTableAll
				},
				tipo:{
					// @ts-ignore
					value: declaracion.tipo,
					label: 'Tipo',
					props: propsObjTableAll
				},
				anio:{
					// @ts-ignore
					value: declaracion.ano_declaracion,
					label: 'Año',
					props: propsObjTableAll
				},
				acciones: {
					value: '',
					label: 'Acciones',
					props: propsObjTableButtons,
					button: {
						funcion: 'declaraciones_genPDFChild',
						icoFont: 'download',
						notOutline: true,
						// @ts-ignore
						data: [ declaracion.id_inversionista, declaracion.ano_declaracion ]
					},
				}
			}
			// @ts-ignore
			declaracion.datosEnTabla = objTable;	
		})
		this.$data.canShow = true;
	},
	methods: {
		genPDF(data: Array<any>) {
			this.$data.dialog = true;
			// @ts-ignore
			API.declaration(data[0], data[1])
				.then((res: any) => {
					this.$data.informacionPDF = res.data.data;
					this.$data.dialog = false;
					setTimeout(() => {
						let b64 = this.$data.informacionPDF.pdfString;
						const linkSource = `data:application/pdf;base64,${b64}`;
						const downloadLink = document.createElement("a");
						const fileName = this.$data.informacionPDF.namePdf;
						downloadLink.href = linkSource;
						downloadLink.download = fileName;
						downloadLink.click();
						EventBus.$emit("snack-success", "Declaración obtenida correctamente");
					}, 500);
				})
				.catch((err: any) => {
					EventBus.$emit("snack-error",'Error al descargar');
					this.$data.dialog = false;
				});
		},
	},
	components: {
		TableResponsive,
		ShowLoading
	}
})
export default class Declarations extends Vue {}
